import { Box, Icon, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { ptBR } from "@mui/x-data-grid/locales";
import { useTransactions } from "./useTransactions";
import { StandardText } from "../../../../../globalComponents/standard";
import Transaction from "../../../../../classes/transaction";

const renderHeader = function () {
  return (
    <Typography fontWeight={"bold"} fontSize={14}>
      {this.headerName}
    </Typography>
  );
};

const columns = [
  {
    field: "sequence",
    headerName: "ID",
    renderHeader,
    width: 140,
  },
  {
    field: "createdAt",
    headerName: "Criado em",
    renderHeader,
    width: 160,
  },
  {
    field: "type",
    headerName: "TIPO",
    renderHeader,
    valueGetter: (_, row) => _ && Transaction.getTypeLabel(row.type),
    width: 120,
  },
  {
    field: "source",
    headerName: "ORIGEM",
    valueGetter: (_, row) => _ && Transaction.getSourceLabel(row.source),
    renderHeader,
    width: 80,
  },
  {
    field: "description",
    headerName: "DESCRIÇÃO",
    renderHeader,
    width: 200,
  },
  {
    field: "amount",
    headerName: "PONTOS",
    renderHeader,
    valueGetter: (_) => _ && _.amount,
    renderCell: ({ row }) => {
      return (
        <StandardText
          size={16}
          style={{
            alignContent: "center",
            padding: 4,
            color: row.amount > 0 ? "teal" : "#ff9100",
            //color: "#fff",
            borderRadius: 3,
          }}
        >
          {row.amount > 0 ? "+" : ""}
          {row.amount}
        </StandardText>
      );
    },
    width: 80,
  },
  {
    field: "createdBy",
    headerName: "QUEM CADASTROU",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedAt",
    headerName: "ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
  {
    field: "updatedBy",
    headerName: "QUEM FEZ A ÚLTIMA ALTERAÇÃO",
    renderHeader,
    width: 180,
  },
];

export default function TransactionsList() {
  const { request, onNextPage } = useTransactions();

  const { data, loading, page, limit, currentPage, totalPages, totalItems } =
    request;

  return (
    <Box sx={{ width: "100%", flex: 1 }}>
      <DataGrid
        initialState={{
          columns: {
            columnVisibilityModel: {
              // Hide columns status and traderName, the other columns will remain visible
              sequence: false,
              updatedAt: false,
              updatedBy: false,
              createdBy: true,
            },
          },
        }}
        disableColumnResize
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        loading={loading}
        paginationMode="server"
        rowHeight={36}
        rows={data}
        isRowSelectable={false}
        columns={columns}
        pageSizeOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        //autoPageSize
        rowCount={totalItems || 0}
        paginationModel={{ page, pageSize: limit }}
        onPaginationModelChange={onNextPage}
        rowsPerPageOptions={[...new Set([limit, 5, 10, 20, 50, 100])]}
        disableSelectionOnClick
        pagination
      />
    </Box>
  );
}
